﻿

/*------------------------------------*\
    #URL
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.url = (function () {
    var priv = {};
    var pub = {};

    /**
     * Private initialization method
     */
    priv.init = function () {
    };

    /**
     * Add a URL parameter (or changing it if it already exists)
     * @param {search} string  - This is typically document.location.search
     * @param {key}    string  - The key to set
     * @param {val}    string  - Value
     */
    pub.addUrlParam = function (search, key, val) {
        var newParam = key + "=" + val;
        var params = "?" + newParam;

        if (search) {
            var keyFound = search.indexOf(key) !== -1;

            // Try to replace an existing parameter
            params = search.replace(new RegExp("([\?&])" + key + "[^&]*"), "$1" + newParam);

            // If key was not found and nothing was replaced, add the new param
            if (!keyFound && params === search) {
                params += "&" + newParam;
            }
        }

        // Push to browser history
        if (history.pushState) {
            var newUrl = window.location.origin + window.location.pathname + params;
            window.history.pushState({ path: newUrl }, "", newUrl);
        }
    };

    /**
     * Get parameter from URL
     * @param {key} string - The key to get
     * @return      string - The value
     */
    pub.getUrlParam = function (key) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");

            if (pair[0] === key) {
                return pair[1];
            }
        }

        return false;
    };

    // Initialize module
    $(function () {
        priv.init();
    });

    // Expose public methods
    return pub;

})();
